<template>
  <li class="vacation-flight">
    <div class="vacation-flight-head">
      <span v-if="type === 'leave'">{{ $t("טיסת הלוך") }}</span>
      <span v-else>{{ $t("טיסת חזור") }}</span>
    </div>
    <div v-if="airline" class="vacation-airline">
      <img v-if="airline" :src="airline.logo_url" />
      <span>{{ flight.airline }}</span>

      <!--      <i class="icon icon-info info" :title="airlineLogoHTML" :data-info="airlineInfoHTML"></i>-->
    </div>
    <div
      class="vacation-flight-body info-block-box"
      :title="airlineLogoHTML"
      :data-info="airlineInfoHTML"
    >
      <div class="vacation-divider"></div>

      <div class="vacation-trip">
        <div class="vacation-airport">
          <div>{{ flight.depart.airport.code || $t("לא זמין") }}</div>
          <span>{{ flight.depart.airport.location || "" }}</span>
        </div>
        <div class="vacation-airport-divider">
          <i
            :class="{
              icon: true,
              'icon-airplane': true,
              'icon-transform-flip': type === 'return',
            }"
          ></i>
        </div>
        <div class="vacation-airport">
          <div>{{ flight.arrive.airport.code || $t("לא זמין") }}</div>
          <span>{{ flight.arrive.airport.location || "" }}</span>
        </div>
      </div>

      <div class="vacation-divider"></div>

      <strong class="vacation-disclaimer"
        >* חובה להתעדכן בשעות הטיסה הסופיות באתר נתב"ג החל
        מ-24 שעות טרם ההמראה</strong
      >

      <ul class="flight-details">
        <li>
          <div>{{ $t("יציאה") }}</div>
          <div>{{ flight.depart.date_pretty || $t("לא זמין") }}</div>
        </li>
        <li>
          <div>{{ $t("שעת המראה") }}</div>
          <div>{{ flight.depart.time || $t("לא זמין") }}</div>
        </li>
        <li>
          <div>{{ $t("טרמינל") }}</div>
          <div>{{ flight.depart.terminal || $t("לא זמין") }}</div>
        </li>
        <li>
          <div>{{ $t("מספר טיסה") }}</div>
          <div>{{ flight.number || $t("לא זמין") }}</div>
        </li>
      </ul>

      <div class="info-link">
        <a
          v-if="airline"
          :data-info="airlineInfoHTML"
          :title="airlineLogoHTML"
          class="info-text-link"
          href="javascript:void(0);"
        >
          {{ $t(">> פרטי הטיסה המלאים ומדיניות כבודה") }}
        </a>

        <a
          v-if="summary"
          class="info-text-link-summary"
          target="_blank"
          @click="openSummary"
        >
          {{ $t("אישור הזמנה online") }}
        </a>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "leave",
    },
    flight: {
      type: Object,
      default: {},
    },
    summary: {
      type: String,
      default: null,
    },
  },

  methods: {
    openSummary(e) {
      e.stopPropagation();
      window.open(this.summary, "_blank");
    },
  },

  computed: {
    airline() {
      let airlines = siteData.customer_data.airlines || {};
      let code = (this.flight.airline || "").trim().toUpperCase();
      return airlines[code] || null;
    },

    airlineLogoHTML() {
      if (!this.airline) {
        return "";
      }

      return `<img src="${this.airline.logo_url}" style="max-height: 21px" />`;
    },

    airlineInfoHTML() {
      if (!this.airline) {
        return "";
      }

      let html = "";
      this.airline.attributes.forEach((attr) => {
        html += "<h4>" + attr.name + "</h4><p>" + attr.detail + "</p>";
      });
      return html;
    },
  },
};
</script>
